import type { AlbumItem } from "@/mocks/gallery";

interface AlbumCardProps {
  album: AlbumItem;
}

export default function AlbumCard({ album }: AlbumCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300">
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={album.cover}
          alt={`${album.title} · ${album.model} 写真合集封面`}
          title={`${album.title} 写真合集 · ${album.category}`}
          className="h-full w-full object-cover object-top transition duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent" />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/92 px-3 py-1 text-xs font-medium text-primary-700">
          {album.category}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-foreground-950/55 px-2.5 py-1 text-xs text-background-50">
          <i className="ri-image-2-line" />
          {album.count}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-4">
          <h3 className="font-heading text-base font-semibold text-background-50 md:text-lg">
            {album.title}
          </h3>
          <div className="mt-1 flex items-center gap-3 text-xs text-background-200">
            <span className="flex items-center gap-1">
              <i className="ri-user-line" />
              {album.model}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" />
              {album.views}
            </span>
          </div>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <p className="line-clamp-3 text-xs leading-relaxed text-foreground-600 md:text-sm">
          {album.desc}
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-2">
          {album.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900"
            >
              #{tag}
            </span>
          ))}
          <span className="ml-auto text-xs text-foreground-400">{album.date}</span>
        </div>
      </div>
    </article>
  );
}